import { render } from "./nuevoPedido.vue?vue&type=template&id=46a6019b&scoped=true"
import script from "./nuevoPedido.vue?vue&type=script&lang=js"
export * from "./nuevoPedido.vue?vue&type=script&lang=js"

import "./nuevoPedido.vue?vue&type=style&index=0&id=46a6019b&scoped=true&lang=css"
import "./nuevoPedido.vue?vue&type=style&index=1&id=46a6019b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a6019b"]])

export default __exports__